import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-question-stars-1",
  "use": "foquz-icon-question-stars-1-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" id=\"foquz-icon-question-stars-1\"><path d=\"M12 1l3.399 7.24L23 9.41l-5.5 5.633L18.798 23 12 19.24 5.202 23 6.5 15.042 1 9.41l7.601-1.168L12 1z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M15 13l-5-3v6l5-3z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol